<template>
  <div>
    <querytitle>
      <template slot="queryleft">
        <div>审核状态：</div>
        <div><el-select v-model="ct" size="mini" style="width:120px;">
          <el-option label="草稿" value="草稿"></el-option>
            <el-option label="待审核" value="待审核"></el-option>
            <el-option label="已通过" value="已通过"></el-option>
            <el-option label="已驳回" value="已驳回"></el-option>
          </el-select></div>
        <div>年度：</div>
        <div>
          <el-select size="mini" v-model="currentYY" @change="selectYY" style="width:120px;">
            <el-option v-for="item in optionYY" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div>模糊查找：</div>
        <div><el-input v-model="querykey" size="mini"></el-input></div>
        <div><el-button type="primary" size="mini" @click="getlist()">查找</el-button></div>
      </template>
      <template slot="queryright">
        <el-button v-if="ct=='草稿'" type="primary" size="mini" @click="add()">新增</el-button>
      </template>
    </querytitle>
    <el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
      <el-table-column prop="ctdate" label="出题时间" width="100"></el-table-column>
      <el-table-column prop="mid" label="专业代码" width="100"></el-table-column>
      <el-table-column prop="mname" label="专业名称" width="100"></el-table-column>
      <el-table-column prop="title" label="选题名称" width="300"></el-table-column>
      <el-table-column prop="tidesc" label="选题描述"></el-table-column>
      <el-table-column prop="checkdate" label="审核时间" width="100"></el-table-column>
      <el-table-column prop="releasetype" label="发布状态" width="100"></el-table-column>
      <el-table-column prop="releasedate" label="发布时间" width="100"></el-table-column>
      <el-table-column prop="yy" label="年份" width="100"></el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope" v-if="scope.row.checktype == '草稿'">
          <div>
            <el-button @click="chk(scope)" type="success" size="mini">提交</el-button>
            <el-button @click="edit(scope)" type="primary" size="mini">编辑</el-button>
            <el-button type="danger" size="mini" @click="del(scope)">删除</el-button>
          </div>                    
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper" :total="rt">
    </el-pagination>
    <el-dialog title="选题信息" :visible="dialogFormVisible" :show-close="false" width="80%">
      <el-form label-width="100px">
        <el-row>
          <el-col :span="8"><el-form-item label="出题时间"><el-date-picker v-model="itemedit.ctdate"></el-date-picker></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="专业名称"><el-select v-model="itemedit.mid" @change="selectmajor">
            <el-option v-for="item in majors" :key="item.majorID" :label="item.majorName" :value="item.majorID"></el-option>
          </el-select></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="年份"><el-input v-model="itemedit.yy" readonly
                @input="inputmethod()"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="选题名称"><el-input v-model="itemedit.title"
                @input="inputmethod()"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="选题描述"><el-input type="textarea" :rows="8" v-model="itemedit.tidesc"
                @input="inputmethod()"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="postdata()">确 定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import querytitle from '@/components/querytitle'
export default {
  components: {
    querytitle
  },
  data() {
    return {
      hh: 500,
      loading: false,
      addflag: false,
      itemlist: [],
      itemindex: 0,
      itemedit: {},
      dialogFormVisible: false,
      rt: 0,
      currentPage: 1,
      pagesize: 10,
      pars: { objname: 'sys_title' },
      ct: '草稿',
      releaset: '待发布',
      querykey: "",
      currentYY: '',
      optionYY: [],
      majors:[]
    };
  },
  created() {
    this.hh = document.documentElement.clientHeight - 160;
    let that = this
    that.getyears(function (res) {
      that.optionYY = res;
      if (that.optionYY.length > 0)
        that.currentYY = that.optionYY[0];
      that.getlist()
    });
    that.PostData("Common/GETLIST",  { objname: "sys_major", wheres: [], PageSize: 1000, CurrentPage: 1 },function(res){
      that.majors = res.data.data;
    })
  },
  methods: {
    selectYY(e) {
      this.getlist()
    },
    selectmajor(e){
      let selectedoption = this.majors.find(option=>option.majorID === e)
      if(selectedoption)
        this.itemedit.mname = selectedoption.majorName
      console.log(this.itemedit)
    },
    add() {
      this.addflag = true;
      this.itemedit.siid = this.GUID();
      this.itemedit.ctdate=  this.FormatDate(new Date())
      this.itemedit.SID = this.CU.cu.sid
      this.itemedit.SNAME = this.CU.cu.sname
      this.itemedit.usertype = this.CU.cu.uclass
      this.itemedit.userid = this.CU.cu.uid
      this.itemedit.yy = this.CU.cu.yy
      this.itemedit.checktype = '草稿'
      this.itemedit.releasetype = '待发布'
      this.dialogFormVisible = true;
    },
    edit(par) {
      this.addflag = false;
      this.itemindex = par.$index;
      this.itemedit = Object.assign({}, par.row);
      this.dialogFormVisible = true;
    },
    del: function (par) {
      let that = this;
      that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var pars = { objname: "sys_title", model: par.row };
        that.PostData("Common/DEL", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" });
            return;
          }
          that.itemlist.splice(par.$index, 1);
        }, function (err) {
          that.$alert(err, { title: "错误", type: 'error' });
        }
        );
      })
        .catch(() => { });
    },
    postdata() {
      let that = this;
      if (!that.itemedit.title) {
        that.$alert("选题名称不能为空", { title: "提示" }); return;
      }
      this.itemedit.ctdate=  this.FormatDate(this.itemedit.ctdate)
      let pars = { objname: "sys_title", model: Object.assign({}, that.itemedit) };
      if (that.addflag) {
        that.PostData("Common/ADD", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          that.itemlist.push(pars.model);
          that.dialogFormVisible = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      } else {
        that.PostData("Common/EDIT", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          that.$set(that.itemlist, that.itemindex, pars.model);
          that.dialogFormVisible = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      }
    },
    chk(par){
      let that = this;
      this.itemindex = par.$index;
      this.itemedit = Object.assign({}, par.row);
      let messtext = "确定要提交此选题吗？";
      let checktype = '待审核'
      that.$confirm(messtext, "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let pars = {"objname":"sys_title","keyfield":"siid","keyvalue":that.itemedit.siid,"fields":{
          "checktype":checktype}
        }
        that.PostData('Common/UPDATE',pars,function(res){
          //this.dialogFormVisible = false;
          that.getlist();
        },function(err){
          that.$alert(err, { title: "错误", type: 'error' });
        })
      }).catch(()=>{})
    },
    getlist() {
      let that = this
      let wherestring = [
        { field: 'usertype', sym: '=', val: this.CU.cu.uclass, oper: 'and' },
        { field: 'userid', sym: '=', val: this.CU.cu.uid, oper: 'and' },
        { field: 'checktype', sym: '=', val: this.ct, oper: 'and' },
        { field: 'yy', sym: '=', val: this.currentYY, oper: 'and' }
      ]
      if (this.querykey) {
        wherestring = [{ field: 'title', sym: 'like', val: '%' + this.querykey + '%', oper: 'and' },]
      }
      let pars = { objname: "sys_title", wheres: wherestring, PageSize: that.pagesize, CurrentPage: that.currentPage }
      that.PostData("Common/GETLIST", pars, function (res) {
        that.itemlist = res.data.data;
        that.rt = res.data.rowTotal
      }, function (err) {
        console.log(err)
        that.$alert(err, { title: "错误" });
      }
      );
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
    uploaded() {
      this.getlist()
    }
  }
};
</script>